import SimpleIBSystemSettingsPanel from './SimpleIBSystemSettingsPanel';

export default SimpleIBSystemSettingsPanel;
